import NeptuneElement from '../../NeptuneElement.js';

class Loader extends NeptuneElement {

    #ariaLive;
    #loader;

    static get LOADER_TYPES() {
        return ['inline', 'page'];
    }

    static get LOADER_SIZES() {
        return ['sm', 'md', 'lg'];
    }

    templateMarkupPage = `
    <dialog role="status">
        <span class="spinner-border" aria-hidden="true"></span>
        <span class="visually-hidden-a11y" aria-live="polite">Loading...</span>
    </dialog>
    `;

    templateMarkupInline = `
    <span role="status" hidden>
        <span class="spinner-border" aria-hidden="true"></span>
        <span class="visually-hidden-a11y" aria-live="polite">Loading...</span>
    </span>
    `;

    componentCssUrl = '/src/components/core/loader/loader.css';

    constructor() {
        super();
    }

    async connectedCallback() {
        const type = this.getAttribute('type');
        this.templateMarkup = type === 'page' ? this.templateMarkupPage : this.templateMarkupInline;
        await super.connectedCallback();
        this.validateRequiredProperties(['type', 'size']);
        this.processInitialAttributesAfterRender(Loader.observedAttributes);
    }

    async disconnectedCallback() {
        await super.disconnectedCallback();
    }

    static get observedAttributes() {
        return ['type', 'size', 'screen-reader-message', 'aria-live', 'show'];
    }

    attributeChangedCallback(name, oldValue, newValue) {

        if (!this.isRendered) {
            return;
        }

        this.processAttribute(name, oldValue, newValue);
    }

    processAttribute(name, oldValue, newValue) {
        switch (name) {
            case 'type': {
                this.validatePropertyValue(name, newValue, Loader.LOADER_TYPES);
                break;
            }
            case 'size': {
                if (this.getAttribute('type') === 'page') {
                    if (newValue !== 'lg') {
                        this.setAttribute('size', 'lg');
                        return;
                    }
                }
                this.validatePropertyValue(name, newValue, Loader.LOADER_SIZES);
                break;
            }
            case 'screen-reader-message': {
                this.#ariaLive.innerHTML = newValue;
                break;
            }
            case 'aria-live': {
                this.#ariaLive.setAttribute('aria-live', newValue);
                break;
            }
            case 'show': {
                const isPage = this.getAttribute('type') === 'page';
                if (newValue !== null) {
                    isPage ? this.#loader.showModal() : this.#loader.removeAttribute('hidden');
                } else {
                    isPage ? this.#loader.close() : this.#loader.setAttribute('hidden', '');
                }
                break;
            }
            default:
                break;
        }
    }

    setEventListeners() {
        super.setEventListeners();
        this.#ariaLive = this.shadowRoot.querySelector('[aria-live]');
        const type = this.getAttribute('type');
        this.#loader = type === 'page' ? this.shadowRoot.querySelector('dialog') : this.shadowRoot.querySelector('span[role="status"]');
    }
}

customElements.define('neptune-loader', Loader);
export default Loader;